
import { Helpers } from '../../../core/src/helpers';

export const  buildSwatches = (variants, disabledSkus) => {
    let prdMap = [];
    let swatches = variants.reduce((swatchGroup, variant)=>{
        if(variant.disabled){
            return swatchGroup
        }
        let prdObj = {sku: variant.product.sku};
        variant.attributes.forEach((attr, index)=>{
            const key = attr.key;
            prdObj[key] = attr.swatch.value;
            const newValue = Object.assign(
                {},
                attr.swatch,
                {variants: [{sku:variant.product.sku, disabled: disabledSkus.includes(variant.product.sku)}],
                groupLevel: index
            });
            if(!swatchGroup[index]){
                swatchGroup[index] = {
                    displayName: attr.displayName,
                    values: [newValue],
                    key
                }
            }else{
                swatchGroup[index].values.push(newValue);
            }
        });
        prdMap.push(prdObj);
        return swatchGroup;
    },[]);
    swatches.forEach((sG)=>
        sG.values.sort((a,b)=>a.ordinal - b.ordinal)
    )
    return {swatches, prdMap};
}

export const getSwatchUrl = (selectedSwatches, basename, dir, slug) => {
    let newFiltersObj = Object.keys(selectedSwatches).reduce((filtersObj, key)=>{
        const selectedSwatch = selectedSwatches[key];
        filtersObj[key] = [selectedSwatch.displayName];
        return filtersObj;
    },{});

    const newFiltersQuery = Helpers.getFilterString({ query: newFiltersObj});
    return `${basename}/${dir}/${slug}/${newFiltersQuery}`
}

export const getSwatchesByProduct = (swatches, sku) => {
    const selectedSwatches = swatches.reduce((r,swatchGroup) => {
        //there should only be one match per group
        r[swatchGroup.key] = swatchGroup.values.find(s => s.variants.filter(v => v.sku === sku).length > 0);
        return r;
    },{});
    
    return selectedSwatches;
}